import { defineComponent as _defineComponent } from 'vue'
import { SDeactivatedUser } from '@slg/web-customer-shared';

import type { NavigationGuardNext, Route } from 'vue-router';

const __default__ = {
  name: 'DeactivatedUserPage',
  beforeRouteEnter(to: Route, _from: Route, next: NavigationGuardNext) {
    if (to.params?.isAuthFailed) {
      next();
    } else {
      // redirect to home page
      next('');
    }
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return { __sfc: true,SDeactivatedUser }
}

})